import { createFileRoute } from '@tanstack/react-router'
import { CdrsPage } from '@/features/finance/cdrs/pages/cdrs-page'
import { requireRole } from '@/lib/auth-guards'

export const Route = createFileRoute('/_authenticated/cdrs/')({
  component: CdrsPage,
  beforeLoad: requireRole(['admin']),
})
